import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizationGuard } from '@appcatalyst/ng-cms-core-lib';

import {LogsComponent} from '@appcatalyst/ng-cms-core-lib';
import {LogsResolve} from '@appcatalyst/ng-cms-core-lib';
import { SourcesComponent } from './sources/sources.component';
import { SourceComponent } from './source/source.component';
import { SourcesResolve } from './sources/sources-resolve.service';
import { SourceResolve } from './source/source-resolve.service';
import { PluginsResolve } from './source/plugins-resolve.service';

const routes: Routes = [
  {
    path: 'logs',
    component: LogsComponent,
    canActivate: [ AuthorizationGuard ],
    data: { roles: [ 'Global.Admin', 'Global.Staff' ] },
    resolve: {
      logs: LogsResolve
    }
  },
  {
    path: 'sources',
    component: SourcesComponent,
    canActivate: [ AuthorizationGuard ],
    data: { roles: [ 'Global.Admin', 'Global.Staff' ] },
    resolve: {
      sources: SourcesResolve
    }
  },
  {
    path: 'sources/new',
    component: SourceComponent,
    canActivate: [ AuthorizationGuard ],
    data: { roles: [ 'Global.Admin', 'Global.Staff' ] },
    resolve: {
      plugins: PluginsResolve
    }
  },
  {
    path: 'sources/:id',
    component: SourceComponent,
    canActivate: [ AuthorizationGuard ],
    data: { roles: [ 'Global.Admin', 'Global.Staff' ] },
    resolve: {
      source: SourceResolve,
      plugins: PluginsResolve
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: []
})
export class AdminRoutingModule { }

export const routedComponents = [
  SourcesComponent,
  SourceComponent
];
